import React, { useState } from "react";

const ExpandAllDetailRowsButton: React.FC<{ api: any }> = ({ api }) => {
  const [allRowsExpanded, setAllRowsExpanded] = useState<boolean>(false);

  const toggleAllRowsExpanded = () => {
    const expandAction = !allRowsExpanded;

    api.forEachNode((node) => {
      if (node?.data?.taskOrIssue === "ISSUE") {
        node.setExpanded(expandAction);
      } else {
        node.setExpanded(false);
      }
    });

    setAllRowsExpanded(expandAction);
    api.refreshCells({ force: true });
  };

  return (
    <div>
      <div
        className={`expandIcon${allRowsExpanded === true ? " rotateIcon" : ""}`}
        onClick={() => toggleAllRowsExpanded()}
      >
        <div className="d-flex flex-column">
          <i className="fa fa-angle-down" style={{ marginBottom: "-5px" }} />
          <i className="fa fa-angle-down" style={{ marginTop: "-4px" }} />
        </div>
      </div>
    </div>
  );
};

export default ExpandAllDetailRowsButton;
